import React, { useEffect, useState } from 'react';
import cx from 'classnames';

import { useAppSelector } from 'redux/reduxHooks';
import { renderToast } from 'components/CustomToast/CustomToast';
import useIsLoadedInsideIframe from 'hooks/useIsLoadedInsideIframe';
import { ReactComponent as CheckCircleIcon } from 'assets/icons/check_circle.svg';
import { ReactComponent as ConfirmIcon } from 'assets/icons/confirm.svg';

import InsuranceInputForm from './InsuranceInputForm';
import InsuranceUploadForm from './InsuranceUploadForm';

import styles from 'components/BookingForm/InsuranceBookingConfirmation/InsuranceBookingConfirmation.module.scss';

interface IInsuranceConfirmation {
  bookingIds: string[];
  insuranceName?: string;
  onDone: () => void;
}

const InsuranceConfirmation = (props: IInsuranceConfirmation) => {
  const { bookingIds, insuranceName, onDone } = props;

  const {
    clinicDetailsSlice: {
      clinicData: { isInsuranceRequired },
    },
  } = useAppSelector((state) => state);

  const isLoadedInsideIframe = useIsLoadedInsideIframe();

  const [isUploadMode, setIsUploadMode] = useState(true);

  const containerClassName = cx({
    [styles['container']]: true,
    [styles['container-iframe']]: isLoadedInsideIframe,
  });

  const headerSectionClassName = cx(
    styles['headerSection'],
    styles['headerSection-iframe']
  );

  const bodySectionClassName = cx(
    styles['bodySection'],
    styles['bodySection-iframe']
  );

  const wrapperClassName = cx({
    [styles['wrapper']]: true,
    [styles['wrapper-iframe']]: isLoadedInsideIframe,
  });

  const insuranceSectionClassName = cx({
    [styles['insurance-section']]: true,
    [styles['insurance-section-required']]: isInsuranceRequired,
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    renderToast({
      type: 'success',
      message:
        'Your booking was successful, you will receive a confirmation email shortly.',
      duration: 30000,
    });
  }, []);

  return (
    <div>
      <div className={wrapperClassName}>
        <ConfirmIcon />

        <div className={styles.title}>Appointment Confirmed!</div>
      </div>

      <div className={containerClassName}>
        <div className={styles['patient-form-container']}>
          <div className={headerSectionClassName}>
            <div className={styles['title']}>
              Enter your Insurance info to expedite your visit?
            </div>
          </div>

          <div className={bodySectionClassName}>
            {!isInsuranceRequired && (
              <span>
                If you do not have this information with you, you can call us
                prior to your visit or present your insurance info at your visit
              </span>
            )}

            {!!insuranceName && (
              <div className={insuranceSectionClassName}>
                <h3>Insurance Carrier: </h3>

                <div>
                  <CheckCircleIcon className={styles['check-circle']} />

                  <span>{insuranceName}</span>
                </div>
              </div>
            )}

            {isUploadMode ? (
              <InsuranceUploadForm bookingIds={bookingIds} onDone={onDone} />
            ) : (
              <InsuranceInputForm bookingIds={bookingIds} onDone={onDone} />
            )}

            <div className={styles['toggle-mode']}>
              {isUploadMode ? (
                <section>
                  <span>Don't have your card?</span>{' '}
                  <button onClick={() => setIsUploadMode(false)}>
                    Enter insurance details manually
                  </button>
                </section>
              ) : (
                <button onClick={() => setIsUploadMode(true)}>
                  Upload photos instead
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsuranceConfirmation;
